/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useState, useCallback, useEffect, useContext,
    useRef,
} from 'react';
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import InvoicesListing from './InvoicesListing';
import InvoicesListSkeleton from './listSkeleton';
import Pagination from '../../Components/Pagination';
import FilterModal from './Modals/filterModal';
import EmptyScreen from '../../Components/GlobalEmplyPage';

function ManageInvoices() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [invoiceList, setinvoiceList] = useState([]);
    const [threeplList, setThreeplList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [isEditId, setisEditId] = useState('');
    const [emptyData, setEmptyData] = useState(false);
    const [totalPage, setTotalPage] = useState('');
    const [sortType, setsortType] = useState('INVOICE_DATE+desc');
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [filterValue, setfilterValue] = useState('');
    const [filterModal, setFilterModal] = useState(false);
    const [Filter, setFilter] = useState({
        order_category: [],
        payment_status: [],
        date_range: [],
        plant_name: [],
        customer_code: [],
    });
    const [selected, setselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const handleFetchthreepl = async () => {
        const data = await distributorService.shippingOrganizationLocationsForFilter();
        if (data.data.success_status === true) {
            setThreeplList(data.data.Items);
        }
    };

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleFetchInvoices = useCallback((() => {
        distributorService.InvoicesList(currentPage, sortType, debouncedSearch, filterValue).then((resp) => {
            if (resp.error === false && resp.data.data.success_status) {
                if (resp?.data?.data?.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setinvoiceList(resp.data.data.Items);
                setCurrentPage(resp.data.data.current_page);
                setTotalPage(resp.data.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, debouncedSearch, filterValue, sortType]);

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };
    const buttonRef = useRef(null);

    useEffect(() => {
        // Function to handle clicks outside the button
        function handleClickOutside(event) {
            if (buttonRef.current && !buttonRef.current.contains(event.target)) {
                setexportClick(false);
            }
        }

        // Add event listener to detect clicks outside the button
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the event listener when the component is unmounted
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [buttonRef]);

    function isExceedingThreeMonths(date1, date2) {
        // const startDate = new Date(date1);
        // const endDate = new Date(date2);

        // // Calculate the difference in years and months
        // const yearsDiff = endDate.getFullYear() - startDate.getFullYear();
        // const monthsDiff = yearsDiff * 12 + (endDate.getMonth() - startDate.getMonth());

        // // Calculate the total days difference
        // const daysDiff = (endDate - startDate) / (1000 * 60 * 60 * 24);

        // // If it's exactly 3 months, check the days difference
        // if (monthsDiff === 3) {
        //     return endDate.getDate() > startDate.getDate() || daysDiff > 90;
        // }
        // // Return true if the difference exceeds 3 months
        // return monthsDiff > 3;
        const startDate = new Date(date1);
        const endDate = new Date(date2);

        // Calculate the total days difference
        const daysDiff = (endDate - startDate) / (1000 * 60 * 60 * 24);

        // If the difference exceeds 90 days, return true
        return daysDiff > 92;
    }
    const showExport = () => {
        if (!filterValue.includes('TRX_DATE')) {
            SetErrorMessage('Please select a date range');
            setcolorValue('warning');
            setTimeout(() => {
                // settitle('');
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        if (filterValue.includes('TRX_DATE') && isExceedingThreeMonths(selected?.start_date, selected?.end_date)) {
            SetErrorMessage('Date range should be between 3 months');
            setcolorValue(true);
            setTimeout(() => {
                // settitle('');
                SetErrorMessage('');
                setcolorValue(false);
            }, 2000);
            return;
        }
        setexportClick(!exportClick);
    };
    const handleExport = useCallback((() => {
        distributorService.InvoicesList(currentPage, sortType, debouncedSearch, filterValue, exportSelected).then((val) => {
            if (val.data.success_status) {
                // setshowPopup(true);
                SetSuccessMessage(val.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(val.data.url, '_blank');
                setTimeout(() => {
                    // settitle('');
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    useEffect(() => {
        handleFetchInvoices();
    }, [handleFetchInvoices]);

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center top-0 left-0 pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Invoices</h5>
                <div className="flex items-center">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-testid="filter-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => {
                            handleFetchthreepl();
                            setFilterModal(true);
                        }}
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                            autoComplete="off"
                        />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative" ref={buttonRef}>
                        <button
                            type="button"
                            id="exportDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            data-testid="export-btn"
                            className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg"
                            onClick={() => showExport()}
                        >
                            Export
                        </button>
                        <ul className={`dropdown-menu min-w-[80px] absolute ${exportClick === true ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]`} aria-labelledby="exportDropdown">
                            <li className="mx-[18px] pb-1.5 mt-5 hover:bg-[#F2F2F3] hover:rounded export">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    data-testid="csv-btn"
                                    onClick={() => {
                                        setexportSelected('csv');
                                    }}
                                >
                                    CSV

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('pdf-converter')}
                                    data-testid="pdf-btn"
                                >
                                    PDF

                                </a>
                            </li>
                            <li className="mx-[18px] pb-1.5 mb-3 hover:bg-[#F2F2F3] hover:rounded">
                                <a
                                    className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block px-1.5 py-0.5"
                                    href="#"
                                    onClick={() => setexportSelected('excel')}
                                    data-testid="excel-btn"
                                >
                                    Excel

                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <InvoicesListSkeleton />
                : (
                    <div>
                        {invoiceList.length > 0 && (
                            <InvoicesListing
                                setinvoiceList={setinvoiceList}
                                invoiceList={invoiceList}
                                isEditId={isEditId}
                                setisEditId={setisEditId}
                                sortType={sortType}
                                setsortType={setsortType}
                                emptyData={emptyData}
                                setEmptyData={setEmptyData}
                                searchValue={searchValue}
                                handleFetchInvoices={handleFetchInvoices}
                            />
                        )}
                        {invoiceList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={invoiceList}
                                currentPage={currentPage}
                                totalPage={totalPage}
                            />
                        )}
                        {filterModal && (
                            <FilterModal
                                filterModal={filterModal}
                                setFilterModal={setFilterModal}
                                Filter={Filter}
                                setFilter={setFilter}
                                filterValue={filterValue}
                                setfilterValue={setfilterValue}
                                handleFilter={handleFilter}
                                threeplList={threeplList}
                                setThreeplList={setThreeplList}
                                handleFetchInvoices={handleFetchInvoices}
                                selected={selected}
                                setselected={setselected}
                                SetSuccessMessage={SetSuccessMessage}
                            />
                        )}
                        {emptyData && (
                            <EmptyScreen
                                search="yes"
                                text="no Invoices"
                                buttonRequired={false}
                                all={debouncedSearch.length > 0 ? 'under searched term' : 'found'}
                            />
                        )}
                    </div>
                )}
        </div>
    );
}

export default ManageInvoices;
